import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, InputNumber, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const RoleMapManager = () => {
  const [roleMaps, setRoleMaps] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRoleMap, setEditingRoleMap] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/role_map"; // Base URL para SGVMAP_ROLE_MAPController

  
  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }
  
  // Obtener la lista de relaciones rol-mapa
  const fetchRoleMaps = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: {
          Authorization: getAuthorization(),
        },
      }); // Asume que hay un endpoint para listar todas las relaciones rol-mapa
      if (!response.ok) throw new Error("Error al obtener las relaciones rol-mapa");
      const data = await response.json();
      setRoleMaps(data);
    } catch (error) {
      message.error("Error al obtener la lista de relaciones rol-mapa");
      console.error(error);
    }
  };

  // Crear o actualizar una relación rol-mapa
  const handleSaveRoleMap = async (values) => {
    const method = editingRoleMap ? "PUT" : "POST";
    const url = editingRoleMap
      ? `${baseURL}/update`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: { 
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar la relación rol-mapa");

      message.success(
        editingRoleMap
          ? "Relación rol-mapa actualizada correctamente"
          : "Relación rol-mapa creada correctamente"
      );
      fetchRoleMaps();
      setIsModalOpen(false);
      setEditingRoleMap(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar la relación rol-mapa");
      console.error(error);
    }
  };

  // Eliminar una relación rol-mapa
  const handleDeleteRoleMap = async (idRol, idMap) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idRol}/${idMap}`, {
        method: "DELETE",
        headers: {
          Authorization: getAuthorization(),
        },
      });
      if (!response.ok) throw new Error("Error al eliminar la relación rol-mapa");

      message.success("Relación rol-mapa eliminada correctamente");
      fetchRoleMaps();
    } catch (error) {
      message.error("Error al eliminar la relación rol-mapa");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (roleMap) => {
    setEditingRoleMap(roleMap);
    form.setFieldsValue(roleMap);
    setIsModalOpen(true);
  };

  // Abrir modal para creación
  const handleCreate = () => {
    setEditingRoleMap(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchRoleMaps();
  }, []);

  const columns = [
    {
      title: "ID Rol",
      dataIndex: "idRol",
      key: "idRol",
    },
    {
      title: "ID Mapa",
      dataIndex: "idMap",
      key: "idMap",
    },
    {
      title: "Orden",
      dataIndex: "orderPosition",
      key: "orderPosition",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta relación?"
            onConfirm={() => handleDeleteRoleMap(record.idRol, record.idMap)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Relaciones Rol-Mapa</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Relación
      </Button>
      <Table columns={columns} dataSource={roleMaps} rowKey={(record) => `${record.idRol}-${record.idMap}`} />

      <Modal
        title={editingRoleMap ? "Editar Relación Rol-Mapa" : "Crear Relación Rol-Mapa"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveRoleMap}
          initialValues={{ idRol: "", idMap: "", orderPosition: 0 }}
        >
          <Form.Item
            name="idRol"
            label="ID Rol"
            rules={[{ required: true, message: "Por favor, ingrese el ID del rol" }]}
          >
            <Input placeholder="ID del Rol" />
          </Form.Item>
          <Form.Item
            name="idMap"
            label="ID Mapa"
            rules={[{ required: true, message: "Por favor, ingrese el ID del mapa" }]}
          >
            <Input placeholder="ID del Mapa" />
          </Form.Item>
          <Form.Item
            name="orderPosition"
            label="Orden"
            rules={[{ required: true, message: "Por favor, ingrese el orden" }]}
          >
            <InputNumber min={1} placeholder="Orden de la Relación" style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default RoleMapManager;
